export default "__VITE_ASSET__fec3dc67__"